export function getDeviceId() {
  const key = "deviceId";
  let id = localStorage.getItem(key);
  if (!id) {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      id = crypto.randomUUID();
    } else {
      id = `web-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }
    localStorage.setItem(key, id);
  }
  return id;
}
